import './OverlayScreen.scss';

export default function OverlayScreen({ open, onClose, className = '', progress }) {
  const hasFadeOutClass = className.includes('overlay--fade-out') || className.includes('overlay-screen--fade-out');
  const overlayClasses = `overlay-screen ${(!open || hasFadeOutClass) ? 'overlay-screen--fade-out' : ''} ${className}`.trim();
  
  const showProgress = typeof progress === 'number';
  const progressValue = Math.max(0, Math.min(100, progress || 0));
  
  return (
    <div
      // onClick={onClose}
      className={overlayClasses}
    >
      <div className="overlay-screen__content">
        <img
          src="/images/logo-animated-256.webp"
          alt="Logo"
          onClick={(e) => e.stopPropagation()}
          className="overlay-screen__logo"
        />
        {showProgress && (
          <div className="overlay-screen__progress-container">
            <div className="overlay-screen__progress-bar-wrapper">
              <div 
                className="overlay-screen__progress-bar"
                style={{ width: `${progressValue}%` }}
              />
            </div>
            <div className="overlay-screen__progress-text">
              {progressValue}%
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
